export enum DaysOfWeekEnum {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}
export const DaysOfWeekDisplay: {
  [key in DaysOfWeekEnum]: string;
} = {
  [DaysOfWeekEnum.SUNDAY]: 'Sunday',
  [DaysOfWeekEnum.MONDAY]: 'Monday',
  [DaysOfWeekEnum.TUESDAY]: 'Tuesday',
  [DaysOfWeekEnum.WEDNESDAY]: 'Wednesday',
  [DaysOfWeekEnum.THURSDAY]: 'Thursday',
  [DaysOfWeekEnum.FRIDAY]: 'Friday',
  [DaysOfWeekEnum.SATURDAY]: 'Saturday',
};
export const DaysOfWeekOptions = [
  {
    value: DaysOfWeekEnum.SUNDAY,
    name: DaysOfWeekDisplay[DaysOfWeekEnum.SUNDAY],
  },
  {
    value: DaysOfWeekEnum.MONDAY,
    name: DaysOfWeekDisplay[DaysOfWeekEnum.MONDAY],
  },
  {
    value: DaysOfWeekEnum.TUESDAY,
    name: DaysOfWeekDisplay[DaysOfWeekEnum.TUESDAY],
  },
  {
    value: DaysOfWeekEnum.WEDNESDAY,
    name: DaysOfWeekDisplay[DaysOfWeekEnum.WEDNESDAY],
  },
  {
    value: DaysOfWeekEnum.THURSDAY,
    name: DaysOfWeekDisplay[DaysOfWeekEnum.THURSDAY],
  },
  {
    value: DaysOfWeekEnum.FRIDAY,
    name: DaysOfWeekDisplay[DaysOfWeekEnum.FRIDAY],
  },
  {
    value: DaysOfWeekEnum.SATURDAY,
    name: DaysOfWeekDisplay[DaysOfWeekEnum.SATURDAY],
  },
];

export enum RoundUpEnum {
  TO_COMPLETE_DAY = 'TO_COMPLETE_DAY',
  TO_NEXT_HALF_DAY = 'TO_NEXT_HALF_DAY',
  NO_ROUNDING = 'NO_ROUNDING',
  ADD_A_DAY = 'ADD_A_DAY',
}

export enum ScheduleTypeEnum {
  DEFAULT = 'DEFAULT',
  EXCEPTION = 'EXCEPTION',
}

export interface BaseSchedule {
  active: boolean;
  createAt: string;
  daysOfWeek: DaysOfWeekEnum[];
  endDate?: string;
  expired: boolean;
  hoursPerShift: number;
  id?: number;
  name: string;
  ongoing: boolean;
  roundup: RoundUpEnum;
  shiftsPerDay: number;
  startDate?: string;
  type: ScheduleTypeEnum;
  updateAt: string;
  utilizationPct: number;
  version?: number;
}

export interface OrgSchedule extends BaseSchedule {
  orgId: number;
}

export interface EqptSchedule extends BaseSchedule {
  equipmentId: number;
}

export interface GenericSchedule extends BaseSchedule {
  parentId: number;
  parentType: 'eqpt' | 'org';
}

export interface TimeframeConfig {
  defaultTurnaroundTimes: null | Partial<OrgSchedule>[];
  exceptionTurnaroundTimes: null | Partial<OrgSchedule>[];
}

export const EMPTY_SCHEDULE: BaseSchedule = {
  active: true,
  createAt: '',
  daysOfWeek: [] as DaysOfWeekEnum[],
  endDate: '',
  expired: false,
  hoursPerShift: 6,
  name: '',
  ongoing: true,
  roundup: RoundUpEnum.NO_ROUNDING,
  shiftsPerDay: 1,
  startDate: '',
  type: ScheduleTypeEnum.DEFAULT,
  updateAt: '',
  utilizationPct: 80,
};
